/** Internal type. DO NOT USE DIRECTLY. */
import { gql } from "@apollo/client"

import * as Types from "../../../../shared/types/__generated__/graphql"

export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never
    }

export type ProjectPhaseFragment = {
  __typename: "ProjectPhase"
  id: string
  value: string
  label: string
}

export const ProjectPhaseFragmentDoc = gql`
  fragment ProjectPhase on ProjectPhase {
    id
    value
    label
  }
`
